// extracted by mini-css-extract-plugin
module.exports = {"root":"EquipmentCardList_root__25pKx"};